<div class="contains-button">
  <div class="editor-header" *ngIf="isViewAll">
    <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
    <span (click)="isViewAll = !isViewAll">{{ currentViewAll.title | translate }}</span>
  </div>
  <ng-container *ngIf="!isViewAll">
    <app-position-out-config [elementChoosing]="objectChoosing" [device]="device"
      [id_parent_choose]=" objectChoosing.id_block ? objectChoosing.id_block : objectChoosing.id_object"></app-position-out-config>

    <app-width-height-config   [device]="device"   [elementChoosing]="objectChoosing" [width]="class['map']['width']" [height]="class['map']['height']"
      (changeWidthHeight)="changeWidthHeight($event)"></app-width-height-config>
    <ul style="padding: 0" nz-menu nzMode="inline" [nzInlineCollapsed]="isCollapsed">
      <li nz-submenu nzTitle="{{'hien_thi'| translate}}" [(nzOpen)]="openMap.menu1" (nzOpenChange)="openHandler('menu1')">
        <div class="button-size m-1 mt-2">
          <!-- Lựa chọn hiển thị cho các thiết bị -->
          <app-hide-show-config [device]="device" [elementChoosing]="objectChoosing">
          </app-hide-show-config>
        </div>
      </li>
      <!-- Cấu hình hình dạng viền -->
      <li nz-submenu nzTitle="{{'kieu_vien' | translate}}" [(nzOpen)]="openMap.menu2" (nzOpenChange)="openHandler('menu2')">
        <app-borders-config [device]="device" [class]="class" [borderClass]="class['map__iframe']"
          [id_object]="objectChoosing._id" [elementChoosing]="objectChoosing">
        </app-borders-config>
        <!-- Nút mở rộng -->
        <div class="item-border my-3" style="float: right">
          <p class="m-0 title-border my-2" (click)="openViewAll(styles_field[0])">
            {{'mo_rong' | translate}} &#8594;
          </p>
        </div>
      </li>
    </ul>
  </ng-container>
  <div class="view-more" *ngIf="isViewAll">
    <div class="view_more-border" *ngIf="currentViewAll.index == 1">
      <app-borders-radius-config [device]="device" [class]="class" [borderRadiusClass]="class['map__iframe']"
        [id_object]="objectChoosing._id" [elementChoosing]="objectChoosing">
      </app-borders-radius-config>
    </div>
  </div>
</div>